import "./scroll.css"

const Scroll = () => {
    return(
        <div class="mouse"></div>
    )
}
export default Scroll